import React from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Pagination,
    Button,
    Menu,
    MenuItem,
    Typography,
    InputAdornment,
    OutlinedInput,
    Fab,
    Box
} from '@mui/material';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { gridSpacing } from 'store/constant';

// project imports
// import Avatar from 'ui-component/extended/Avatar';
// import { UserProfile } from 'types/user-profile';
// import { useDispatch } from 'store';
// import { getUsersListStyle1 } from 'store/slices/user';

// assets
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import ChatBubbleTwoToneIcon from '@mui/icons-material/ChatBubbleTwoTone';
// import BlockTwoToneIcon from '@mui/icons-material/BlockTwoTone';
import { ListProps } from 'types/list';
import MainCard from '../cards/MainCard';
import { IconMapPin, IconSearch } from '@tabler/icons';

// assets
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import { point } from 'leaflet';

// ==============================|| USER LIST 1 ||============================== //

const ReusableList = (props: ListProps) => {
    const theme = useTheme();
    const [data, setData] = React.useState(props.content.data);
    const [anchorEl, setAnchorEl] = React.useState<Element | ((element: Element) => Element) | null | undefined>(null);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(10);
    const [pageCount, setPageCount] = React.useState(Math.ceil(data.length / rpg));
    const [allowCSVExport, setAllowCSVExport] = React.useState(false);

    React.useEffect(() => {
        console.log('ReusableList content data', props.content.data);
        setData(props.content.data);
        setAllowCSVExport(props.allowCSVExport);
    }, [props.content.data]);

    React.useEffect(() => {
        setPageCount(Math.ceil(data.length / rpg));
    }, [data, rpg]);

    const handleClick = (event: React.MouseEvent) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event: any) => {
        setrpg(parseInt(event?.target?.attributes[3]?.value, 10));
        setpg(0);
        setAnchorEl(null);
    };

    const handlePageChange = (event: any) => {
        setpg(event?.target?.attributes[3]?.value.split(' ').pop() - 1);
    };

    const rowClicked = (row: any) => {
        props.onRowClicked(row);
    };

    const handleSearchChange = (event: any) => {
        let tempData: any[] = [];

        props.content.data.forEach((row) => {
            const rowData: any[] = Object.keys(row).map((key) => {
                return String(row[key]).toLowerCase();
            });
            for (let i = 0; i < rowData.length; i++) {
                if (rowData[i].includes(event.target.value.toLowerCase())) {
                    tempData.push(row);
                    break;
                }
            }
        });

        if (event.target.value === '') setData(props.content.data);
        else setData(tempData);
    };

    //const handleButtonClick = (buttonText: any) => {
    function handleButtonClick(buttonText: string, id: string) {
        props.onButtonClicked(buttonText, id);
    }

    function handleDeleteButtonClick(id: string) {
        props.onDeleteButtonClicked(id);
    }

    const escapeCSV = (value: string): string => {
        if (value == null) {
            return '';
        }

        const needsEscaping = /[",\r\n]/.test(value);
        if (needsEscaping) {
            // Escape double quotes by replacing " with ""
            const escapedValue = value.replace(/"/g, '""');
            return `"${escapedValue}"`;
        }

        return value;
    };

    const handleDataForExport = () => {
        let mappedData: string[] = [];
        const mappedHeaders = props.content.headers.map((header) => header.value);
        mappedData.push(mappedHeaders.join(','));
        props.content.data.forEach((rowData) => {
            let datapoints: string[] = [];
            mappedHeaders.forEach((key) => {
                datapoints.push(escapeCSV(rowData[key]));
            });
            mappedData.push(datapoints.join(','));
        });
        const filename = 'export_' + new Date().toISOString().replace('T', '-').replace(':', '-').split('.')[0].slice(0, -3) + '.csv';
        downloadBlob(mappedData.join('\r\n'), filename, 'text/csv;charset=utf-8;');
    };

    function downloadBlob(content: string, filename: string, contentType: string) {
        // Create a blob
        var blob = new Blob([content], { type: contentType });
        var url = URL.createObjectURL(blob);

        // Create a link to download it
        var pom = document.createElement('a');
        pom.href = url;
        pom.setAttribute('download', filename);
        pom.click();
    }

    return (
        <MainCard
            title={
                <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
                    <Grid item>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                flexWrap: 'wrap'
                            }}
                        >
                            <Typography variant="h3">{props.title}</Typography>
                            <span>
                                {props.showAddButton && (
                                    <Box sx={{ ml: 2 }}>
                                        <Fab
                                            size="small"
                                            color="primary"
                                            aria-label="new todo add"
                                            onClick={() => props.onAddButtonClicked()}
                                        >
                                            <AddRoundedIcon fontSize="small" />
                                        </Fab>
                                    </Box>
                                )}
                            </span>
                        </div>
                    </Grid>

                    <Grid item>
                        {allowCSVExport ? (
                            <Button variant="contained" style={{ marginRight: '1rem' }} onClick={handleDataForExport}>
                                CSV Export
                            </Button>
                        ) : (
                            <div></div>
                        )}

                        <OutlinedInput
                            id="input-search-list-style1"
                            placeholder="Search"
                            startAdornment={
                                <InputAdornment position="start">
                                    <IconSearch stroke={1.5} size="16px" />
                                </InputAdornment>
                            }
                            size="small"
                            onChange={handleSearchChange}
                        />
                    </Grid>
                </Grid>
            }
            content={false}
        >
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            {props.content.headers &&
                                props.content.headers.map((header, index) => <TableCell key={index}>{header.title}</TableCell>)}
                            {props.buttons && props.buttons.map((text, index) => <TableCell key={text}></TableCell>)}
                            {props.showDeleteButton && <TableCell key={'delete'}>Delete</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data &&
                            data.slice(pg * rpg, pg * rpg + rpg).map((row, index) => (
                                <TableRow hover key={index} style={{ maxHeight: '10px' }}>
                                    {row &&
                                        props.content.headers.map((header, headerIndex) => (
                                            <TableCell key={headerIndex} onClick={() => rowClicked(row)}>
                                                {row[header.value]}
                                            </TableCell>
                                        ))}
                                    {props.buttons &&
                                        props.buttons.map((text, index2) => (
                                            <TableCell>
                                                <Button key={text} variant="contained" onClick={() => handleButtonClick(text, row.Id)}>
                                                    {text}
                                                </Button>
                                            </TableCell>
                                        ))}
                                    {props.showDeleteButton && (
                                        <TableCell key={'delete'}>
                                            <DeleteIcon
                                                fontSize="large"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => handleDeleteButtonClick(row.Id)}
                                            />
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid item xs={12} sx={{ p: 3 }}>
                <Grid container justifyContent="space-between" spacing={gridSpacing}>
                    <Grid item>
                        <Pagination count={pageCount} color="primary" onClick={handlePageChange} />
                    </Grid>
                    <Grid item>
                        <Button
                            size="large"
                            sx={{ color: theme.palette.grey[900] }}
                            color="secondary"
                            endIcon={<ExpandMoreRoundedIcon />}
                            onClick={handleClick}
                        >
                            {rpg} Rows
                        </Button>
                        {anchorEl && (
                            <Menu
                                id="menu-user-list-style1"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                variant="selectedMenu"
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                                transformOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right'
                                }}
                            >
                                <MenuItem onClick={handleClose} value={10}>
                                    10 Rows
                                </MenuItem>
                                <MenuItem onClick={handleClose} value={20}>
                                    20 Rows
                                </MenuItem>
                                <MenuItem onClick={handleClose} value={30}>
                                    30 Rows
                                </MenuItem>
                            </Menu>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default ReusableList;
